module.exports = __webpack_public_path__ + "img/2_mfw.fa41df59.jpg";